/* eslint-disable indent */
import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { AnaliseDescontoService } from '../services/analise-desconto.service';
import { AnaliseDesconto } from '../models/analise-desconto';
import { AnaliseDescontoQuestionario } from '../models/analise-desconto-questionario';
import {
  AnaliseDescontoStatus,
  TipoAplicacao,
  TipoArquivo,
  TipoArquivoAnexo,
  TipoCalculoPedido,
  TipoFila
} from '../models/enum';
import { AnaliseDescontoAnexo } from '../models/analise-desconto-anexo';
import { AnaliseDescontoAnexoService } from '../services/analise-desconto-anexo.service';
import { ArquivoService } from '../services/arquivo.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ResumoPedido } from '../models/resumoPedido';
import { PedidoService } from '../services/pedido.service';
import { ItemPedido, Pedido } from '../models/pedido';
import { PremissasService } from '../services/premissas.service';
import { PremissasOrcPed } from '../models/premissas-orc-ped';
import { Cliente } from '../models/cliente';
import { ClienteService } from '../services/cliente.service';
import { UsuarioLogado } from '../models/usuario-logado';
import { GlobalService } from '../services/global.service';
import { Frete } from '../models/frete';
import { VendaEntrega } from '../models/venda-entrega';
import { FreteService } from '../services/frete.service';
import swal from 'sweetalert2';
import { DadosCalculo } from '../models/dados-calculo';
import { CondicaoDePagamentoService } from '../services/condicao-de-pagamento.service';
import { SeguroService } from '../services/seguro.service';
import { Seguro } from '../models/seguro';
import { VendaSeguro } from '../models/venda-seguro';
import { CondicaoDePagamento } from '../models/condicao-de-pagamento';
import { InserirValorModalComponent } from '../modals/inserir-valor-modal/inserir-valor-modal.component';
import { MatDialog } from '@angular/material';
import { AnaliseDescontoStatusLog } from '../models/analise-desconto-status-log';
import { MargemLucroComponent } from '../margem-lucro/margem-lucro.component';
import { HistoricoAnaliseDescontoComponent } from '../historico-analise-desconto/historico-analise-desconto.component';
import { PremissasSistema } from '../models/premissas-sistema';

// jquery
declare const $: any;

@Component({
  selector: 'app-analise-desconto',
  templateUrl: './analise-desconto.component.html',
  styleUrls: ['./analise-desconto.component.scss']
})
export class AnaliseDescontoComponent implements OnInit, OnChanges {
  @Input() analiseDesconto: AnaliseDesconto;
  @Input() resumoPedido: ResumoPedido;
  @Input() podeEditar: boolean;

  questionarioSolicitacao: AnaliseDescontoQuestionario[];
  questionarioConclusao: AnaliseDescontoQuestionario[];
  anexos: AnaliseDescontoAnexo[];
  logs: AnaliseDescontoStatusLog[] = [];
  tabSelecionada;

  pedido: Pedido;
  itens: ItemPedido[];

  premissas: PremissasOrcPed = new PremissasOrcPed();
  cliente: Cliente;
  clienteFaturamento: Cliente;
  descontoMaximo = 0;
  descontoFrete = 0;

  usuarioLogado: UsuarioLogado;
  frete: Frete;
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  alterou = true;

  usandoMultiFormasPagamento = false;
  valorTotalMultiFormaPagamento = 0;
  valorTaxaCond = 0;
  taxaCondicao = 0;

  seguros: Seguro[] = [];

  valorLiquido = 0;

  valorSeguro = 0;

  potencia = 0;

  segurosObrigatorios: VendaSeguro[] = [];
  segurosManuais: VendaSeguro[] = [];
  segurosObrigatoriosRemovidos: VendaSeguro[] = [];

  valorArredondamento;
  valorSemDesconto = 0;
  valorMinimo = 0;

  AnaliseDescontoStatus = AnaliseDescontoStatus;

  premissasSistema: PremissasSistema = new PremissasSistema();

  @ViewChild('margemLucro', { static: false }) margemLucro: MargemLucroComponent;
  @ViewChild('historicoAnaliseDescontoComp', { static: false })
  historicoAnaliseDescontoComp: HistoricoAnaliseDescontoComponent;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private analiseDescontoService: AnaliseDescontoService,
    private analiseDescontoAnexoService: AnaliseDescontoAnexoService,
    private pedidoService: PedidoService,
    private premissasService: PremissasService,
    private clienteService: ClienteService,
    private globalService: GlobalService,
    private freteService: FreteService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private seguroService: SeguroService,
    public dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.descontoMaximo = this.usuarioLogado.limDesc;
    await this.buscarPremissasOrcPed();
    await this.buscarPremissasSistema();
    this.buscarDadosAnalise();
    await this.buscarPedido();
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarPremissasOrcPed() {
    try {
      this.carregandoService.mostra('buscarPremissasOrcPed');
      this.premissas = await this.premissasService.consultarPremissasOrcPed().toPromise();

      if (this.premissas.podeAlterarValorFinal) {
        this.buscarValorArredondamento();
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasOrcPed');
    }
  }

  buscarValorArredondamento() {
    this.carregandoService.mostra('buscarValorArredondamento');
    this.premissasService.consultarValorArredondamento().subscribe(
      (f) => {
        this.valorArredondamento = f.valor;
        this.carregandoService.esconde('buscarValorArredondamento');
      },
      (erro) => {
        this.carregandoService.esconde('buscarValorArredondamento');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async alterarValorTotal() {
    await this.atualizaValores(TipoCalculoPedido.SimularValorFinal, Number(this.analiseDesconto.valorAutorizado));
    await this.atualizaDesconto();

    this.analiseDesconto.descontoValido =
      this.analiseDesconto.valorAutorizado >= this.valorMinimo &&
      this.analiseDesconto.valorAutorizado <= this.valorSemDesconto &&
      this.pedido.valorDa >= 0;

    if (this.analiseDesconto.descontoValido) {
      this.analiseDesconto.tipoDesconto = 1;
      this.analiseDesconto.descontoAutorizado = Number(this.pedido.valorDa);
      this.analiseDesconto.percentualAutorizado = Number(this.pedido.percentual);

      this.margemLucro.calcularValoresCalculadoraMargem();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.analiseDesconto && changes.analiseDesconto.currentValue !== changes.analiseDesconto.previousValue) {
      this.buscarDadosAnalise();
    }
  }

  buscarDadosAnalise() {
    if (this.analiseDesconto) {
      this.buscarQuestionarioPreenchido(TipoAplicacao.AnaliseDescontoSolicitacao);

      if (
        this.analiseDesconto.status === AnaliseDescontoStatus.DescontoConcedido ||
        this.analiseDesconto.status === AnaliseDescontoStatus.DescontoNaoConcedido
      ) {
        this.buscarQuestionarioPreenchido(
          this.analiseDesconto.status === AnaliseDescontoStatus.DescontoConcedido
            ? TipoAplicacao.AnaliseDescontoConclusaoPositiva
            : TipoAplicacao.AnaliseDescontoConclusaoNegativa
        );
      }

      this.buscarAnexos();
      this.buscarLogs();
    }
  }

  buscarQuestionarioPreenchido(tipoAplicacao: TipoAplicacao) {
    this.carregandoService.mostra('buscarQuestionarioPreenchido');
    this.analiseDescontoService.consultarQuestionarioPreenchido(this.analiseDesconto.id, tipoAplicacao).subscribe(
      (dados) => {
        switch (tipoAplicacao) {
          case TipoAplicacao.AnaliseDescontoSolicitacao:
            this.questionarioSolicitacao = dados;
            break;

          case TipoAplicacao.AnaliseDescontoConclusaoPositiva:
          case TipoAplicacao.AnaliseDescontoConclusaoNegativa:
            this.questionarioConclusao = dados;
            break;

          default:
            break;
        }

        this.carregandoService.esconde('buscarQuestionarioPreenchido');
      },
      (erro) => {
        this.carregandoService.esconde('buscarQuestionarioPreenchido');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarAnexos() {
    this.carregandoService.mostra('buscarAnexos');
    this.analiseDescontoAnexoService.consultarPorIdAnaliseDesconto(this.analiseDesconto.id).subscribe(
      (dados) => {
        this.anexos = dados;
        this.carregandoService.esconde('buscarAnexos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarAnexos');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarLogs() {
    this.carregandoService.mostra('buscarLogs');
    this.analiseDescontoService.consultarLogPorIdAnalise(this.analiseDesconto.id).subscribe(
      (dados) => {
        this.logs = dados;
        this.carregandoService.esconde('buscarLogs');
      },
      (erro) => {
        this.carregandoService.esconde('buscarLogs');
        this.notificacaoService.erro(erro);
      }
    );

    if (this.historicoAnaliseDescontoComp !== null && this.historicoAnaliseDescontoComp !== undefined) {
      this.historicoAnaliseDescontoComp.buscarAnalisesDoPedido();
    }
  }

  calcularDesconto() {
    return (
      ((this.analiseDesconto.valorDoPedido - this.analiseDesconto.valorSolicitado) * 100) /
      this.analiseDesconto.valorDoPedido
    );
  }

  selectedTabChange(tab) {
    this.tabSelecionada = tab;
  }

  async buscarCondicoesDePagamento() {
    try {
      this.carregandoService.mostra('buscaCondicoesDePagamento');

      if (
        this.pedido.formasPagamento !== null &&
        this.pedido.formasPagamento !== undefined &&
        this.pedido.formasPagamento.length > 0
      ) {
        const conds = await this.condicaoDePagamentoService
          .consultarPorFormas(this.pedido.formasPagamento.map((p) => p.idFormaPag).join(','))
          .toPromise();
        this.aplicarLimitesCondicoesDePagamento(conds);
        await this.atualizarTaxaDeCondicao(conds);
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaCondicoesDePagamento');
    }
  }

  aplicarLimitesCondicoesDePagamento(condicoesDePagamento: Array<{ disabled?: boolean } & CondicaoDePagamento> = null) {
    let houveAlteracao = false;
    const condicoesAntigas = condicoesDePagamento || [];

    const condicoesNovas = condicoesAntigas.map((cond) => {
      const foraDoLimite = this.condicaoDePagamentoService.verificaForaDoLimite(cond, this.pedido.valorTotal);

      if (foraDoLimite !== cond.disabled) {
        cond.disabled = foraDoLimite;
        houveAlteracao = true;
      }

      return { ...cond };
    });

    if (!houveAlteracao) {
      return;
    }

    if (
      this.pedido.formasPagamento === null ||
      this.pedido.formasPagamento === undefined ||
      this.pedido.formasPagamento.length === 0
    ) {
      return;
    }

    const selecionados = condicoesNovas.filter((c) =>
      this.pedido.formasPagamento.some((f) => f.idCondPag === c.idCondPag)
    );

    if (selecionados === null || selecionados === undefined || selecionados.length === 0) {
      if (this.pedido.multiFormaPagamento) {
        this.pedido.formasPagamento = [];
      } else {
        this.pedido.formasPagamento[0].idCondPag = undefined;
      }
    } else {
      selecionados.forEach((selecionado) => {
        if (selecionado.disabled) {
          if (this.pedido.multiFormaPagamento) {
            this.pedido.formasPagamento
              .filter((p) => p.idCondPag === selecionado.idCondPag)
              .forEach((p) => {
                this.pedido.formasPagamento.splice(this.pedido.formasPagamento.indexOf(p), 1);
              });
          } else {
            this.pedido.formasPagamento[0].idCondPag = undefined;
          }
        }
      });
    }
  }

  async atualizarTaxaDeCondicao(conds) {
    if (this.pedido.multiFormaPagamento) {
      this.taxaCondicao = 0;
    } else {
      this.taxaCondicao =
        this.pedido.formasPagamento === null ||
        this.pedido.formasPagamento === undefined ||
        !conds.some((c) => c.idCondPag === this.pedido.formasPagamento[0].idCondPag)
          ? 0
          : conds.find((c) => c.idCondPag === this.pedido.formasPagamento[0].idCondPag).taxaDA;
    }
  }

  async buscarPedido() {
    this.carregandoService.mostra('buscarPedido');

    try {
      const buscarItens = () =>
        this.pedidoService
          .bC_Itens(
            this.analiseDesconto.idCupom,
            false, // atualizarValores
            true, // buscarEstoque
            false, // buscarFoto
            false // duplicando
          )
          .toPromise();

      const pedidoPromise = this.pedidoService
        .bC_Pedido(
          this.analiseDesconto.idCupom,
          false, // atualizarValores
          true, // buscarEstoque
          false // duplicando
        )
        .toPromise();

      const enderecoPromise = this.pedidoService.bC_EnderecoDeEntrega(this.analiseDesconto.idCupom).toPromise();

      const deveAguardarPedido =
        this.premissas.vendaProgramada === true && this.resumoPedido && this.resumoPedido.orcamento === true;

      const itensPromise = deveAguardarPedido ? pedidoPromise.then(() => buscarItens()) : buscarItens();

      const [pedido, itens, enderecoDeEntrega] = await Promise.all([pedidoPromise, itensPromise, enderecoPromise]);

      this.pedido = pedido;
      this.pedido.cupomDesconto = null;

      if (this.pedido.valorDa < 0) {
        this.pedido.valorDa = this.pedido.valorDa * -1;
      }

      this.pedido.valorFinal = this.pedido.valorTotalCalculado;
      this.valorTaxaCond = this.pedido.taxaDA;
      this.itens = itens;

      this.pedido.da = 0;
      this.enderecoDeEntrega = enderecoDeEntrega;

      await this.buscarCliente();

      if (this.pedido.vendaDireta) {
        await this.buscarClienteFaturamento();
      }

      await this.buscarCondicoesDePagamento();
      await this.buscarSeguros();

      this.valorSemDesconto = await this.atualizaValores(TipoCalculoPedido.SimularDesconto, 0);

      this.valorMinimo = await this.atualizaValores(
        TipoCalculoPedido.SimularDesconto,
        (Number(this.pedido.valorTotal) * this.descontoMaximo) / 100
      );

      if (this.analiseDesconto.status !== AnaliseDescontoStatus.DescontoConcedido) {
        this.analiseDesconto.valorAutorizado = Number(this.analiseDesconto.valorSolicitado);
      }

      if (
        this.analiseDesconto.valorAutorizado >= this.valorMinimo &&
        this.analiseDesconto.valorAutorizado <= this.valorSemDesconto
      ) {
        await this.alterarValorTotal();
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPedido');
    }
  }

  buscarPedidoOld() {
    this.carregandoService.mostra('buscarPedido');
    this.pedidoService.consultarCompleto(this.analiseDesconto.idCupom, null, null, false, false).subscribe(
      async (dados) => {
        this.pedido = dados.venda;
        this.pedido.cupomDesconto = null;
        if (this.pedido.valorDa < 0) {
          this.pedido.valorDa = this.pedido.valorDa * -1;
        }

        this.pedido.valorFinal = this.pedido.valorTotalCalculado;
        this.valorTaxaCond = this.pedido.taxaDA;
        this.itens = dados.itens;

        this.pedido.da = 0;

        this.enderecoDeEntrega = dados.enderecoDeEntrega;

        await this.buscarCliente();
        if (this.pedido.vendaDireta) {
          await this.buscarClienteFaturamento();
        }
        await this.buscarCondicoesDePagamento();
        await this.buscarSeguros();

        ((this.valorSemDesconto = await this.atualizaValores(TipoCalculoPedido.SimularDesconto, 0)),
          (this.valorMinimo = await this.atualizaValores(
            TipoCalculoPedido.SimularDesconto,
            (Number(this.pedido.valorTotal) * this.descontoMaximo) / 100
          )));
        if (this.analiseDesconto.status !== AnaliseDescontoStatus.DescontoConcedido)
          this.analiseDesconto.valorAutorizado = Number(this.analiseDesconto.valorSolicitado);

        if (
          this.analiseDesconto.valorAutorizado >= this.valorMinimo &&
          this.analiseDesconto.valorAutorizado <= this.valorSemDesconto
        ) {
          await this.alterarValorTotal();
        }

        this.carregandoService.esconde('buscarPedido');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPedido');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarFrete() {
    try {
      this.carregandoService.mostra('buscarFrete');

      this.frete = await this.freteService
        .buscarPorIbge(
          this.enderecoDeEntrega !== null && this.enderecoDeEntrega !== undefined
            ? this.enderecoDeEntrega.ibge
            : this.cliente.ibge,
          this.premissas.pCentroDistribuicao ? this.pedido.idFornecedor : undefined
        )
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFrete');
    }
  }

  async buscarCliente() {
    try {
      this.carregandoService.mostra('buscaCliente');
      this.cliente = await this.clienteService.consultarPorIdCliente(this.pedido.cliente, true).toPromise();

      this.descontoFrete = this.cliente.descFrete;

      await this.buscarFrete();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaCliente');
    }
  }

  async buscarSeguros() {
    try {
      this.carregandoService.mostra('buscarSeguros');
      this.seguros = await this.seguroService
        .consultarLista(this.pedido.flag === 4 && this.pedido.status === 0 ? null : this.pedido.idCupom)
        .toPromise();
    } catch (err) {
      this.notificacaoService.erro(err);
    } finally {
      this.carregandoService.esconde('buscarSeguros');
    }
  }

  async atualizaValores(tipoCalculo: TipoCalculoPedido = TipoCalculoPedido.Normal, valorParaSimular?) {
    try {
      this.carregandoService.mostra('calcular');

      if (this.frete !== null && this.frete !== undefined) {
        this.frete.prazoTotal = Number(this.frete.prazoTotal);
      }

      let percentualFreteAvulso = null;

      if (this.premissas.bloquearTipoFreteVendaDireta && this.pedido.origemGI === 2) {
        let totalValorCif = 0;
        let totalValorFob = 0;

        this.itens.forEach((p) => {
          if (p.qt > 0) {
            totalValorCif += p.precoCif * p.qt;
            totalValorFob += p.pUnitario * p.qt;
          }
        });

        percentualFreteAvulso = totalValorCif === 0 ? 0 : (1 - totalValorFob / totalValorCif) * 100;
      }

      const qtModulos = this.itens.reduce((total, it) => {
        if (it.produtoTela.familia === 2) {
          return total + it.qt;
        }
        if (it.produtoTela.familia === 7) {
          return (
            total +
            it.produtoTela.composicao.reduce((compTotal, comp) => {
              return comp.produtoMP.familia === 2 ? compTotal + comp.qt * it.qt : compTotal;
            }, 0)
          );
        }
        return total;
      }, 0);

      let dadosCalculo: DadosCalculo = {
        valorProdutos: this.pedido.valorTotal,
        valorServico:
          this.pedido.valorServico !== null && this.pedido.valorServico !== undefined
            ? Number(this.pedido.valorServico)
            : 0,
        valorDoServicoAcima: false,
        valorDa:
          tipoCalculo === TipoCalculoPedido.SimularDesconto
            ? valorParaSimular
            : this.pedido.valorDa !== null && this.pedido.valorDa !== undefined
              ? Number(this.pedido.valorDa)
              : 0,
        percentual:
          this.pedido.percentual !== null && this.pedido.percentual !== undefined ? Number(this.pedido.percentual) : 0,
        tipoFrete: this.pedido.tipoFrete,
        valorFrete: this.pedido.frete !== null && this.pedido.frete !== undefined ? Number(this.pedido.frete) : 0,
        localizacao: this.pedido.tipoLocalizacao,
        da: this.pedido.da,
        percentualFreteAvulso: percentualFreteAvulso,
        frete: this.frete,
        idDescarga: this.pedido.idDescarga,
        freteManual: this.pedido.freteManual,
        freteDigitado: this.pedido.freteManual,
        msgFreteIntegrador: '',
        mostrarMsgFreteIntegrador: false,
        descontoFrete: this.descontoFrete,
        taxaCondicao: this.taxaCondicao,
        valorTaxaCond: this.valorTaxaCond,
        valorTotal: this.pedido.valorFinal,
        valorServicoEntregaEditado: false,
        servicoEntrega: this.pedido.servicoEntrega,
        valorServicoEntrega: this.pedido.valorServicoEntrega,
        valorProjeto:
          this.pedido.valorProjeto !== null && this.pedido.valorProjeto !== undefined
            ? Number(this.pedido.valorProjeto)
            : 0,
        seguros: [...this.seguros],
        segurosManuais: [...this.segurosManuais],
        segurosSelecionados:
          this.pedido.seguros !== null && this.pedido.seguros !== undefined ? [...this.pedido.seguros] : [],
        segurosObrigatorios: [...this.segurosObrigatorios],
        segurosObrigatoriosRemovidos: [...this.segurosObrigatoriosRemovidos],
        potencia: this.potencia,
        idCupom: this.pedido.idCupom,
        valorSeguro: this.valorSeguro,
        valorLiquido: this.valorLiquido !== null && this.valorLiquido !== undefined ? Number(this.valorLiquido) : 0,
        valorProjetoLiquido:
          this.pedido.valorProjetoLiquido !== null && this.pedido.valorProjetoLiquido !== undefined
            ? Number(this.pedido.valorProjetoLiquido)
            : 0,
        voucher: this.pedido.voucher,
        dadosVoucher: this.pedido.dadosVoucher,
        valorVoucher: this.pedido.valorVoucher,
        alterou: tipoCalculo === TipoCalculoPedido.Normal ? this.alterou : true,
        origem: this.pedido.origemGI,
        pedidoFlag: this.pedido.flag,
        tipoCalculo: tipoCalculo,
        valorFinalParaSimular: tipoCalculo === TipoCalculoPedido.SimularValorFinal ? valorParaSimular : null,
        status: this.pedido.status,
        qtModulos: qtModulos,
        tipoCIF: this.pedido.tipoCIF,
        itens: this.itens,
        ipi: this.pedido.ipi,
        multiFormaPagamento: false,
        formasPagamento: this.pedido.formasPagamento,
        cpfCnpj: this.pedido.vendaDireta
          ? this.clienteFaturamento.tipo === 0
            ? this.clienteFaturamento.cnpj
            : this.clienteFaturamento.cpf
          : this.cliente.tipo === 0
            ? this.cliente.cnpj
            : this.cliente.cpf,
        idCd: this.pedido.idFornecedor,
        uf: this.enderecoDeEntrega.uf,
        impostos: this.pedido.impostos,
        valorImpostos: this.pedido.valorImpostos,
        calcularImpostosApi: true,
        descontoIndividual: this.pedido.descontoIndividual
      };

      dadosCalculo = await this.pedidoService.calcular(dadosCalculo).toPromise();

      if (dadosCalculo.valorDoServicoAcima) {
        swal({
          title: 'ATENÇÃO!!!',
          html:
            'Valor do serviço acima do permitido!!!<br>Limite: ' +
            ((this.pedido.valorTotal * this.premissas.limiteRepasse) / 100).toLocaleString(),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);
      }

      switch (tipoCalculo) {
        case TipoCalculoPedido.Normal:
          {
            this.pedido.valorTotal = dadosCalculo.valorProdutos;
            this.pedido.valorServico = dadosCalculo.valorServico;
            this.pedido.valorDa = dadosCalculo.valorDa;
            this.pedido.percentual = dadosCalculo.percentual;
            this.pedido.tipoFrete = dadosCalculo.tipoFrete;
            this.pedido.frete = dadosCalculo.valorFrete;
            this.pedido.tipoLocalizacao = dadosCalculo.localizacao;
            this.pedido.da = dadosCalculo.da;
            this.pedido.idDescarga = dadosCalculo.idDescarga;
            this.descontoFrete = dadosCalculo.descontoFrete;
            this.taxaCondicao = dadosCalculo.taxaCondicao;
            this.valorTaxaCond = dadosCalculo.valorTaxaCond;
            this.pedido.valorFinal = dadosCalculo.valorTotal;
            this.pedido.servicoEntrega = dadosCalculo.servicoEntrega;
            this.pedido.valorServicoEntrega = dadosCalculo.valorServicoEntrega;
            this.pedido.valorProjeto = dadosCalculo.valorProjeto;
            this.seguros = [...dadosCalculo.seguros];
            this.segurosManuais = [...dadosCalculo.segurosManuais];
            this.pedido.seguros = [...dadosCalculo.segurosSelecionados];
            this.segurosObrigatorios = [...dadosCalculo.segurosObrigatorios];
            this.segurosObrigatoriosRemovidos = [...dadosCalculo.segurosObrigatoriosRemovidos];
            this.potencia = dadosCalculo.potencia;
            this.valorSeguro = dadosCalculo.valorSeguro;
            this.valorLiquido = dadosCalculo.valorLiquido;
            this.pedido.valorProjetoLiquido = dadosCalculo.valorProjetoLiquido;
            this.pedido.voucher = dadosCalculo.voucher;
            this.pedido.dadosVoucher = dadosCalculo.dadosVoucher;
            this.pedido.valorVoucher = dadosCalculo.valorVoucher;
            this.pedido.ipi = dadosCalculo.ipi;
            this.pedido.formasPagamento = dadosCalculo.formasPagamento;
            this.pedido.impostos = dadosCalculo.impostos;
            this.pedido.valorImpostos = dadosCalculo.valorImpostos;

            this.aplicarLimitesCondicoesDePagamento();

            if (this.alterou && this.pedido.valorTotalFixo !== this.pedido.valorFinal) {
              this.pedido.valorTotalFixo = null;
            }
          }
          break;

        case TipoCalculoPedido.SimularDesconto:
          return dadosCalculo.valorTotal;

        case TipoCalculoPedido.SimularValorFinal:
          this.pedido.valorDa = Number(dadosCalculo.valorDa.toFixed(2));
          this.pedido.valorFinal = dadosCalculo.valorTotal;
          this.pedido.frete = dadosCalculo.valorFrete;
          this.valorTaxaCond = dadosCalculo.valorTaxaCond;
          this.valorSeguro = dadosCalculo.valorSeguro;
          this.valorLiquido = dadosCalculo.valorLiquido;
          if (this.alterou && this.pedido.valorTotalFixo !== this.pedido.valorFinal) {
            this.pedido.valorTotalFixo = null;
          }
          this.pedido.formasPagamento = dadosCalculo.formasPagamento;
          break;

        default:
          break;
      }
    } catch (erro) {
      console.log('erro:', erro);
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('calcular');
    }
  }

  async atualizaDesconto() {
    let valortotal = 0;
    this.itens.forEach((p) => (valortotal += Number(p.qt) * Number(p.pUnitario)));
    this.pedido.valorTotal = Number(valortotal.toFixed(2));

    if (this.pedido.flag === 4) {
      const percentualCalculado = (this.pedido.valorDa * 100) / Number(this.pedido.valorTotal);
      this.pedido.percentual =
        percentualCalculado === 0
          ? 0
          : Number(percentualCalculado.toFixed(4)) === 0
            ? 0.0001
            : Number(percentualCalculado.toFixed(4));
    }
  }

  async buscarClienteFaturamento() {
    try {
      this.carregandoService.mostra('buscarClienteFaturamento');
      this.clienteFaturamento = await this.pedidoService.consultarClienteVendaDireta(this.pedido.idCupom).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarClienteFaturamento');
    }
  }
}
